<!--
   Created by qing on 2020/8/6
   Des: 
-->
<template>

  <div
    class="component-filter-content"
    @click="onClickSelectFilterData(filter)">
    <template v-if="filter.value && filter.value.length">
      <van-tag
        v-for="value in filter.value.slice(0, 3)"
        v-if="showValue2SubmitValue(value)"
        class="filter-tag"
        plain
        type="warning"
        size="large">
        {{ showValue2SubmitValue(value) }}
      </van-tag>
      <span v-if="filter.value.length > 3" style="margin-left: 10px;">...</span>
    </template>


    <!--选择value-->
    <van-popup
      class="select-filter-data-popup"
      v-model="selectDataConfig.visible"
      :style="{ width: '80%' }"
      get-container="body"
      position="right">
      <van-search
        v-model="selectDataConfig.searchInput"
        placeholder="请输入搜索关键词"
        @input="selectDataConfig.onSearch"
        @clear="selectDataConfig.onSearch"
        @search="selectDataConfig.onSearch"
      />
      <template v-if="selectDataConfig.filterCondition">
        <template v-if="selectDataConfig.dataList && selectDataConfig.dataList.length">
          <div v-if="isMultiple" class="select-container multiple-select-container">
            <van-checkbox-group v-model="selectDataConfig.selectValue">
              <van-checkbox
                v-for="item in selectDataConfig.dataList"
                :key="Math.random()"
                :name="item.submitValue">
                {{item.showValue}}
              </van-checkbox>
            </van-checkbox-group>

            <div class="footer">
              <van-button type="default" @click="selectDataConfig.onClickCancel">取消</van-button>
              <van-button type="primary" @click="selectDataConfig.onClickConfirm">确定</van-button>
            </div>
          </div>
          <div v-else class="select-container single-select-container">
            <van-radio-group v-model="selectDataConfig.singleSelectValue">
              <van-radio
                v-for="item in selectDataConfig.dataList"
                :key="Math.random()"
                :name="item.submitValue"
                @click.stop.native="selectDataConfig.onClickConfirmSingleSelect">
                {{item.showValue}}
              </van-radio>
            </van-radio-group>
          </div>
        </template>
        <div v-else class="empty-container">
          暂无数据
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
  import {
    FORM_ITEM__CHECKBOX,
    FORM_ITEM__SINGLE_CHOOSE,
    FORM_ITEM__DROPDOWN, FORM_ITEM__IMAGE_CHOOSE
  } from "../../RyForm/types";

  export default {

    props: {
      isMultiple: {
        type: Boolean,
        default: true
      },
      formId: {
        type: String,
        default: ''
      },
      fields: {
        type: Array,
        default: () => []
      },
      filter: {
        type: Object,
        default: () => {
        }
      },
      filterValue: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        loading: false,
        // 选择筛选数据弹框
        selectDataConfig: {
          visible: false,
          filterCondition: null,
          selectValue: [],
          singleSelectValue: '',
          originDataList: [],
          dataList: [],
          dataListMap: {},
          searchInput: '',

          open: (condition) => {
            this.selectDataConfig.searchInput = ''
            this.selectDataConfig.filterCondition = condition
            this.selectDataConfig.selectValue.splice(0, this.selectDataConfig.selectValue.length, ...condition.value)
            this.selectDataConfig.singleSelectValue = condition.value[0] || ''
            this.selectDataConfig.visible = true
            this.fetchDataList()
          },

          onSearch: () => {
            if (!this.selectDataConfig.searchInput.length) {
              this.selectDataConfig.dataList.splice(0, this.selectDataConfig.dataList.length, ...this.selectDataConfig.originDataList)
              return
            }
            const searchResults = []
            this.selectDataConfig.originDataList.forEach(item => {
              const results = PinyinMatch.match(item.showValue, this.selectDataConfig.searchInput)
              if (results) {
                searchResults.push(item)
              }
            })
            this.selectDataConfig.dataList.splice(0, this.selectDataConfig.dataList.length, ...searchResults)
          },

          onClickCancel: () => {
            this.selectDataConfig.visible = false
          },

          onClickConfirm: () => {
            this.selectDataConfig.filterCondition.value.splice(
              0, this.selectDataConfig.filterCondition.value.length,
              ...this.selectDataConfig.selectValue)
            this.selectDataConfig.visible = false
          },
          onClickConfirmSingleSelect: () => {
            this.selectDataConfig.filterCondition.value.splice(
              0, this.selectDataConfig.filterCondition.value.length,
              this.selectDataConfig.singleSelectValue)
            this.selectDataConfig.visible = false
          }
        },
      }
    },
    created() {
      this.fetchDataList()
    },
    methods: {

      // 点击选择数据
      onClickSelectFilterData(item) {
        this.selectDataConfig.open(item)
      },

      fetchFieldFormFieldId(fieldId) {
        return this.fields.filter(field => field.dataId === fieldId)[0] || {}
      },

      showValue2SubmitValue(value) {
        const item = this.selectDataConfig.dataList.filter(item => item.submitValue === value)[0]
        return item ? item.showValue : ''
      },

      fetchDataList() {

        if (!this.selectDataConfig.dataList.length) {
          if (this.filter.type === FORM_ITEM__CHECKBOX ||
            this.filter.type === FORM_ITEM__SINGLE_CHOOSE ||
            this.filter.type === FORM_ITEM__DROPDOWN ||
            this.filter.type === FORM_ITEM__IMAGE_CHOOSE) {

            const field = this.fetchFieldFormFieldId(this.filter.fieldId)
            const res = []
            field.options.forEach(opt => {
              res.push({
                submitValue: opt.id,
                showValue: opt.id
              })
            })
            this.selectDataConfig.dataList.push(...res)
            this.selectDataConfig.originDataList.push(...res)
          } else {
            this.loading = true
            this.$store.dispatch('actionFetchFilterDataSourceList', {
              appId: this.$store.getters.currentAppId,
              companyId: this.$store.getters.currentCompanyId,
              formId: this.formId,
              fieldId: this.filter.fieldId
            }).then(res => {
              this.selectDataConfig.dataList.push(...res)
              this.selectDataConfig.originDataList.push(...res)
            })
              .catch(console.error)
              .finally(() => {
                this.loading = false
              })
          }
        }
      }
    }
  }
</script>

<style lang="less">

  .component-filter-content {
    border: 1px dashed #e6e6e6;
    min-height: 40px;
    padding: 10px;
    font-size: 14px;
    color: #323233;

    .van-tag {
      margin: 0 5px 5px 5px;
    }

    .van-cell {
      padding: 0;
    }

    .van-radio-group {
      display: flex;

      .van-radio {
        margin-right: 20px;
      }
    }
  }

  .select-filter-data-popup {
    height: 100%;

    .select-container {
      height: calc(100% - 54px);
      border-top: 1px solid #e6e6e6;
    }

    .multiple-select-container {

      .van-checkbox-group {
        height: calc(100% - 44px);
        overflow: auto;
        padding: 10px;

        .van-checkbox {
          padding: 10px 0;
          font-size: 14px;
          border-bottom: 1px solid #e6e6e6;
        }
      }

      .footer {
        height: 44px;

        .van-button {
          width: 50%;
        }
      }
    }

    .single-select-container {
      overflow: auto;
      padding: 10px;

      .van-radio-group {

        .van-radio {
          padding: 10px 0;
          font-size: 14px;
          border-bottom: 1px solid #e6e6e6;
        }
      }
    }

    .empty-container {
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>